export const MenuBall = ({ className, ...props }: { className?: string; [x: string]: any }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      {...props}
    >
      <path d="M4.16417 26.9211C6.94035 29.638 10.7176 31 15.4999 31C20.4341 31 24.2513 29.638 26.9514 26.9211C29.648 24.2005 31 20.3546 31 15.3835C31 10.5652 29.648 6.79588 26.9514 4.07895C24.2513 1.35836 20.4341 0 15.4999 0C10.7176 0 6.94035 1.35836 4.16417 4.07895C1.388 6.79588 0 10.5652 0 15.3835C0 20.3546 1.388 24.2005 4.16417 26.9211Z" />
    </svg>
  )
}
export const listBallPathD =
  'M344.62 0.173539C396.928 0.173541 437.43 13.2543 466.058 39.3677C494.686 65.5383 509 101.063 509 146.087C509 192.516 494.686 228.452 466.058 253.864C437.43 279.273 396.928 292 344.62 292L164.38 291.826C112.072 291.826 71.5704 279.099 42.942 253.69C14.3801 228.279 -2.02947e-06 192.342 0 145.913C1.96808e-06 100.889 14.3801 65.3647 42.942 39.1942C71.5704 13.0808 112.072 -2.28649e-06 164.38 0L344.62 0.173539Z'

export const ListBall = ({ className, ...props }: { className?: string; [x: string]: any }) => {
  return (
    <svg
      width="509"
      height="292"
      viewBox="0 0 509 292"
      className={className}
      fill="currentColor"
      {...props}
    >
      <path d={listBallPathD} />
    </svg>
  )
}
